import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersRoleplayingEvaluationMutateType } from "~/domains";

type RequestDataType = {
  roleplayingConditionId: string;
  body: {
    myEvaluationGoodContent: string;
    myEvaluationImproveContent: string;
    otherUserEvaluationGoodContent: string;
    otherUserEvaluationImproveContent: string;
  };
};

const request = ({ roleplayingConditionId, body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersRoleplayingEvaluationMutateType>(
      `/api/managers/roleplaying_conditions/${roleplayingConditionId}/roleplaying_evaluations`,
      {
        roleplayingEvaluation: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersRoleplayingConditionsRoleplayingEvaluationsCreate =
  ({ options = {} }: PropsType = {}): UseMutationResult<
    ApiManagersRoleplayingEvaluationMutateType,
    RequestDataType
  > => {
    return useMutation(request, { ...options });
  };
